import { render, staticRenderFns } from "./MeetingDetail.vue?vue&type=template&id=b38dd990&scoped=true&"
import script from "./MeetingDetail.vue?vue&type=script&lang=js&"
export * from "./MeetingDetail.vue?vue&type=script&lang=js&"
import style0 from "./MeetingDetail.vue?vue&type=style&index=0&id=b38dd990&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38dd990",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow})
